"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_FAILURE = exports.UPDATE_SUCCESS = exports.UPDATE_REQUEST = void 0;
exports.UPDATE_REQUEST = 'me/UPDATE/REQUEST';
exports.UPDATE_SUCCESS = 'me/UPDATE/SUCCESS';
exports.UPDATE_FAILURE = 'me/UPDATE/FAILURE';
//# sourceMappingURL=types.js.map